require("navigation");
//require("map");

new WOW().init();

// On égalise des éléments en fonction de leur hauteur //
function hauteurEgale(group) {
	tallest = 0;
	group.each(function() {
		thisHeight = $(this).height();
		if(thisHeight > tallest) {
			tallest = thisHeight;
		}
	});
	group.css('height',tallest+'px');
}

$(window).load(function() {
	if (window.innerWidth > 992) {
		hauteurEgale($(".same-height"));
	};
})

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

// Ajout dynamique des svg sur les bulles de la chronologie //
function chronologie_creation() {
  if($('.timeline').length) {
    // on modifie la ligne de fond du premier élément
    $('.timeline:eq(0)').addClass('timeline-first');
  }
  // on ajoute les éléments svg aléatoirement
  $('.timeline').each(function(){
    // 5 positions possibles par "objet image" : pos-0 / pos-1 / pos-2 / pos-3 / pos-4
    // on définit le nombre d'objets à pos-0 (masqués)
    var masques_nbr = Math.floor(Math.random() * 2 + 1);
    var visibles_nbr = 4 - masques_nbr;
    // on créé le tableau
    if(masques_nbr == 2) {
      var positions = [0,0];
    } else {
      var positions = [0];
    }
    // on initialise position pour tester que deux objets ne sont pas à la même place
    var position_1 = 0;
    var position_2 = 0;
    var boucle = 0;
    if(boucle == 0) {
      var position = Math.floor(Math.random() * 4 + 1);
      positions.push(position);
      position_1 = position;
      boucle = 1;
    }
    while(boucle == 1) {
      var position = Math.floor(Math.random() * 4 + 1);
      if(position != position_1) {
        positions.push(position);
        position_2 = position;
        boucle = 2;
      }
    }
    if(masques_nbr == 1) {
      while(boucle == 2) {
        var position = Math.floor(Math.random() * 4 + 1);
        if(position != position_1 && position != position_2) {
          positions.push(position);
          boucle = 3;
        }
      }
    }
    // on mélange l'ordre des positions
    shuffle(positions);
    // puis on associe aux "objets image" leur position aléatoirement
    $(this).children('.timeline-feuille-1').removeClass('pos-0').addClass('pos-'+positions[0]);
    $(this).children('.timeline-feuille-2').removeClass('pos-0').addClass('pos-'+positions[1]);
    $(this).children('.timeline-feuille-3').removeClass('pos-0').addClass('pos-'+positions[2]);
    $(this).children('.timeline-feuille-4').removeClass('pos-0').addClass('pos-'+positions[3]);
  });
}

$(document).ready(function(){
  // Ajout dynamique des svg sur les bulles de la chronologie //
  chronologie_creation();
});

var lang = document.documentElement.lang;

if($('#map').length){
  $('#map').vectorMap({
  	map: 'fr_merc',
  	backgroundColor: 'transparent',
  	zoomOnScroll: false,
  	zoomButtons : false,
  	regionStyle: {
  		initial: {
  			fill: '#5F7BA5'
  		},
      hover: {
        "fill-opacity": 1,
        fill: '#282d32'
      },
    },
    onRegionClick: function (event, code) {
      event.preventDefault();
      if(lang == 'fr') {
        window.location = "/fr/trouver-un-distributeur-farmstar/?departement=" + code +"#distribList";
      } else {
        window.location = "/en/find-a-farmstar-distributor/?departement=" + code +"#distribList";
      }
    }
  });
  var deptID = window.location.search;
  if(deptID.length) {
    deptID = deptID.split('=');
    if(deptID[1]) {
      $('path[data-code="'+deptID[1]+'"]').attr('fill', '#282d32');
    }
  }
}
